
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CommonEmpty extends Vue {
  @Prop() private emptyStyle!: object;
  isDark = false;
  mounted() {
    this.isDark = window.getCssStyle() === 'black';
  }
}
